import React from 'react';
import { Shell } from './components'

const App = () => {
  return (
    <Shell />
  )
}

export default App;